import { Box } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import { headList, stepperData } from "./parts";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { BusinessContext } from "../../context/businessContext";
import TkTable from "../../components/atoms/TkTable";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import "./_style.scss";
import { httpAPI_FAC017, httpAPI_FAC021 } from "./api/request";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import {
  formClassFacility,
  FormKbn,
  Status,
} from "../../assets/data/Constants";

/**
 * SCRC050028_部分解除　入力内容確認
 */
const SCRC050028: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any[]>([]);
  const [isOpenDateDialog, setIsOpenDateDialog] = useState(false);
  const [activeStep, setActiveStep] = useState(2);
  const [isBtnVisible, setIsBtnVisible] = useState(true);

  const userType = state.authInfo?.userType;
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const contractorDisplay = isKiko
    ? businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName
    : "";
  const contractNo = isKiko
    ? businessState.common?.contractorNo || ""
    : state.authInfo?.contractorNo || "";
  const applyId = location.state?.applyId ?? businessState.job_16?.applyId;

  const handleInit = async () => {
    try {
      const res = await httpAPI_FAC021({
        applyId: applyId,
      });
      if (res.resultCd === "I0000") {
        if (
          !(
            res.latestApplyStatus === Status["届出待ち"] ||
            res.latestApplyStatus === Status["差戻し一時保存"]
          )
        ) {
          setActiveStep(4);
          setIsBtnVisible(false);
        }
        setBodyList(formatData(res));
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  const createDownloadLink = (facilityNo: string, formList: [any]) => {
    const formData = formList.find(
      (item: any) =>
        facilityNo === item.facilityNo &&
        item.formKbn === FormKbn["施設書類"] &&
        item.formClass === formClassFacility["部分解除同意書"]
    );
    return formData ? (
      <TkDownloadLink
        base64filedata={formData.fileBase64}
        dataname={formData.fileName}
        downloadBase64={true}
      />
    ) : (
      <></>
    );
  };
  const formatData = (data: any) => {
    return data.targetFacilityList.map((item: any) => {
      return [
        {
          children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
        },
        {
          children: item.facilityKind,
        },
        {
          children: item.facilityKbn,
        },
        {
          children: item.cancelDate,
        },
        {
          children: item.cancelMaStaffNum,
        },
        {
          children: createDownloadLink(item.facilityNo, data.formList),
        },
        {
          children: item.cancelReason,
        },
      ];
    });
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = async (date?: any) => {
    try {
      const res = await httpAPI_FAC017({
        contractorNo: contractNo,
        applyId: applyId,
        screenId: "SCRC050028",
        receptionDate: date,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setIsOpenDateDialog(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC050028">
      <TkStepper steps={stepperData} activeStep={activeStep} />
      <TkInfoManual rule={"\\n"}>
        {isKiko
          ? labelids.labelid.LBLC050028_01.replaceAll("機構へ提出する", "申請")
          : labelids.labelid.LBLC050028_01}
      </TkInfoManual>
      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={contractorDisplay}
        />
      )}

      <TkTable headList={headList} bodyList={bodyList} />
      <Box className="btnGroup">
        <TkBackButton />
        {isBtnVisible && (
          <TkButton onClick={() => setIsOpenDateDialog(true)}>
            {isKiko ? "申請" : "機構へ提出する"}
          </TkButton>
        )}
      </Box>

      {isKiko ? (
        <TkDateDialog
          open={isOpenDateDialog}
          onOky={handleSave}
          onCancel={() => setIsOpenDateDialog(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={isOpenDateDialog}
          onOky={handleSave}
          onCancel={() => setIsOpenDateDialog(false)}
          title="確認（機構へ提出する）"
          contextText="機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRC050028;
